import cx from 'classnames';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {TRANSLATION_KEYS} from 'locale';

type Props = {
    className?: string;
    or?: boolean,
    word?: string,
}
const T_KEYS = TRANSLATION_KEYS.COMMON.ALL;

export const Divider: React.FC<Props> = ({or, word: wordProp, className}) => {
    const {t} = useTranslation();
    const word = useMemo(() => or ? t(T_KEYS.OR) : wordProp, [or, t, wordProp]);
    return word ?
        <div className={cx(className, 'tw-flex tw-items-center')}>
            <div className='tw-border-t tw-border-dark tw-w-1/2' />
            <span className='tw-mx-2'>{word}</span>
            <div className='tw-border-t tw-border-dark tw-w-1/2' />
        </div> :
        <div className={cx(className, 'tw-border-t tw-border-default')} />;
};